'use client'

import cx from 'classnames'
import React from 'react'

import Animation, { AnimationChildrenType } from '@/components/LandingPage/ContentModel/Animation'

export default function VerticalAnimation({
  targetComponent,
  // NOTE: 画面の下から20%の位置に来たら表示する
  rootMargin = '0px 0px -20% 0px',
}: {
  targetComponent: AnimationChildrenType
  rootMargin?: string
}) {
  return (
    <Animation
      animationClassName={cx('animate-[vertical-slide_1s_cubic-bezier(.4,.15,.2,1)_both]')}
      rootMargin={rootMargin}
      isTransparent={true}
      targetComponent={targetComponent}
    />
  )
}
